<template>
  <div class="checkout-promo">
    <h4>Промокод</h4>
    <form @submit.prevent="apply">
      <ui-input
        v-model="inputCode"
        :readonly="!!cartCode"
        placeholder="Введите промокод"
      />
      <ui-button
        type="submit"
        :text="cartCode ? 'Удалить' : 'Применить'"
        :secondary="!!cartCode"
        :disabled="!cartCode && !code"
        :loading="loading"
      />
    </form>
    <p
      v-if="cartCode"
      v-text="discountText"
    />
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'checkout-promo',

  data: () => ({
    code: '',
    loading: false,
  }),

  computed: {
    ...mapGetters({
      PROMO_CODES: 'cart/promoCodes',
      PRODUCTS: 'cart/products',
    }),
    inputCode: {
      get() {
        return this.cartCode || this.code;
      },
      set(value) {
        this.code = value;
      },
    },
    cartCode() {
      return this.PROMO_CODES?.[0]?.code || '';
    },
    discountProductsCount() {
      return this.PRODUCTS.reduce((acc, p) => {
        if ((p.discounts || []).some(d => d.type === 'promocode')) {
          acc += p.lineIds.length;
        }
        return acc;
      }, 0);
    },
    discountText() {
      return this.cartCode
        ? `Применен к ${this.discountProductsCount} ${this.$options.filters.decl(this.discountProductsCount, 'товар', ['у', 'ам', 'ам'])}`
        : '';
    },
  },

  methods: {
    ...mapActions({
      SET_PROMO: 'cart/setPromo',
      DELETE_PROMO: 'cart/deletePromo',
    }),
    apply() {
      this.loading = true;
      if (this.cartCode) return this.deletePromo();
      this.SET_PROMO(this.code)
        .then(() => {

        })
        .catch(({ error = {} } = {}) => {
          this.$store.dispatch('notifications/create', {
            title: 'Ошибка',
            message: error.detail || 'Промокод не найден.',
          });
        })
        .finally(() => {
          this.loading = false
        });
    },
    deletePromo() {
      this.DELETE_PROMO(this.cartCode)
        .finally(() => {
          this.code = '';
          this.loading = false;
        });
    },
  }


}
</script>

<style lang="scss">
.checkout-promo form {
  display: flex;
  .ui-input {
    min-height: auto;
    flex: 1;
  }
  .ui-input-input {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .ui-button {
    margin-left: -1px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}
.checkout-promo p {
  margin-top: 8px;
  font-size: 12px;
  line-height: 20px;
}

@include breakpoint("tablet") {
  .checkout-promo form {
    width: 288px;

    .ui-input {
      width: 330px;
      flex: initial;
    }
  }
  .checkout-promo p {
    margin-top: 12px;
  }
}

@include breakpoint("desktop") {
  .checkout-promo {
    form {
      width: 422px;
    }

    p {
      font-size: 14px;
    }
  }
}
</style>
